import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['audios', 'videos', 'listenLink', 'watchLink', 'dropdownSelect'];

  hiddenClass = 'hidden';
  selectedClass = 'border-b-md';

  showWatch() {
    this.hideAudios();
    this.showVideos();
    this.watchLinkTarget.classList.add(this.selectedClass);
    this.listenLinkTarget.classList.remove(this.selectedClass);
  }

  showListen() {
    this.hideVideos();
    this.showAudios();
    this.listenLinkTarget.classList.add(this.selectedClass);
    this.watchLinkTarget.classList.remove(this.selectedClass);
  }

  showVideos() {
    this.videosTarget.classList.remove(this.hiddenClass);
  }

  showAudios() {
    this.audiosTarget.classList.remove(this.hiddenClass);
  }

  hideVideos() {
    this.videosTarget.classList.add(this.hiddenClass);
  }

  hideAudios() {
    this.audiosTarget.classList.add(this.hiddenClass);
  }

  dropdownChange(event) {
    event.target.value === 'listen' ? this.showListen() : this.showWatch()
  }
}
